import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as KDRES from './kbar.dres.js'
import * as KDATA from './kbar.data.js'

const analyclass = 'KbarAnaly'

// 浮动窗口永远只能有一个存在 无论是菜单还是其他
function showFkinfo(chart, result, keyWord) {
    // console.log(result.rect)
    const islr = DATAS.getfloatLR(result.rect, result.mousePos.x)
    const frect = {
        left: islr === 'right' ? result.rect.left : result.rect.left + result.rect.width - 115 * Init.scale,
        top: result.rect.top,
        width: 115 * Init.scale,
        height: 210 * Init.scale,
    }
    const curKey = Init.getcurKey()
    chart.setKeyWord(curKey, keyWord.static)

    chart.initFwindow('finfo', frect)
    const fwinLayoutCfg = {
        layout: CLAPI.ChartRes.CHART_LAYOUT,
        config: CLAPI.Utils.mergeObjectOfDeep(KDRES.CHART_KBAR_FWIN, CLAPI.ChartRes.CHART_BOARD),
        rectMain: frect
    }
    chart.openFwindow('kbar.info', 'system.board', fwinLayoutCfg, function (result) {
        //  console.log(result)
    })
    // console.log(fwinchar);
    
    chart.setFwindow('kbar.info', KDATA.curdateToFwin(result.data))
}

function showFminute(chart, inData, result) {
    const nowLR = DATAS.getfloatLR(result.rect, result.mousePos.x)
    const frect = {
        style:  'splitly',
        left: nowLR === 'right' ? result.rect.left : result.rect.left + result.rect.width - 500 * Init.scale,
        top: result.rect.top,
        width: 500 * Init.scale,
        height: 300 * Init.scale,
    }

    let curKey = Init.getcurKey()
    let curDate = result.data[0]

    function onDrawMinute() {
        const curkinfo = {
            curdate : curDate,
            coindot: 2,
            agoprc : CLAPI.getData(inData['minute'], 'agop', 0)
        }
        chart.setKeyWord(curKey, curkinfo)
        const axisXinfo = DATAS.AminuToAxisXinfo(inData['minute'], 'msec')
        chart.setAxisXinfo(axisXinfo.timeInfo, axisXinfo.dateInfo)
        chart.setTradeDate(curDate)

        chart.initFwindow('fline', frect)
        const maincfg = {
            layout: CLAPI.ChartRes.CHART_LAYOUT,
            config: CLAPI.Utils.mergeObjectOfDeep({
                    style: 'fwindow',
                },
                CLAPI.ChartRes.CHART_FIXED_FIRST),
            rectMain: CLAPI.getChartRect(frect, 1, 2, 0, 0)
        }
        chart.openFwindow('kbar.minu', 'system.fixed', maincfg, function (result) {
            // if (result.event === 'keydown') {
            //     chart.stopFwindow()
            // }
        })
        const curvcfg = {
            layout: CLAPI.ChartRes.CHART_LAYOUT,
            config: CLAPI.Utils.mergeObjectOfDeep({
                    style: 'fwindow',
                    axisX: {
                        display: 'normal',
                    },
                },
                CLAPI.ChartRes.CHART_FIXED_SECOND),
            rectMain: CLAPI.getChartRect(frect, 1, 2, 0, 1)
        }
        chart.openFwindow('kbar.curv', 'system.fixed', curvcfg, function (result) {
            //  console.log(result)
        })
        
        const minus = DATAS.AminuToMinute(inData['minute'])
        // console.log(minus);
        chart.setFwindow('kbar.curv', minus)
        chart.setFwindow('kbar.minu', minus)
    }
    // console.log(result);
    
    Init.sendCommand({
            cmds: {
                "minute": {
                    "cmd": "get",
                    "subject": curKey + ".alpha_minu1",
                    "service": "atdb/minu1",
                    "info": {
                        "sub-date": curDate
                    }
                },
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                inData['minute'] = datas['minute']
                console.log(inData);
                onDrawMinute()
            }
        });
}

function setAnalyHead(curChart, inData, region) {
    const chartName = 'AnalyHead'
    const chart = curChart.getChart(chartName)

    const headRect = CLAPI.getChartRect(region)
    const headLayoutCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: KDRES.CHART_ANALY_HEAD,
        rectMain: headRect

    }
    const analyindex = Init.getUserInfo(analyclass, 'analyindex', 0)

    headLayoutCfg.config.selectIndex = analyindex
    
    // const headchart = 
    chart.createChart('user.kbar', 'system.ctrls', headLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            console.log('Analy', result)
            Init.setUserInfo(analyclass, 'analyindex', result.selectIndex)
            onChangeAnaly(inData, false)
        }
    })

}

function setKbar(curChart, inData, region) {
    const chartName = 'Kbar'
    const chart = curChart.getChart(chartName)

    const curKey = Init.getcurKey()
    inData.keyWord = DATAS.AinfoToKeyWord(inData['minfo'])
    chart.setKeyWord(curKey, inData.keyWord.static)

    const axisXinfo = DATAS.AdateToAxisXinfo(inData['iobar'], 'msec')
    // 设置坐标显示信息
    chart.setAxisXinfo(axisXinfo)
    inData['axisXinfo'] = axisXinfo

    let kbars = KDATA.IodateToAvgKbar(inData['iobar'], inData.keyWord)
    let mainDataName = 'KBAR'
    chart.setData(mainDataName, kbars)
    // console.log(axisXinfo);
    // console.log(kbars);
    
    const mainRect = CLAPI.getChartRect(region, 1, 3, 0, 0)
    // console.log(mainRect);
    // 设置界面信息和绑定数据
    const mainLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 10,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep({
                title: {
                    label: inData.keyWord.static.name + ' ' + curKey,
                },
            },
            KDRES.CHART_KBAR_MAIN),
        rectMain: mainRect

    }

    const maarea = Init.getUserInfo(chartName, 'maarea')
    if (maarea === 'grade') {
        mainLayoutCfg.config.lines = KDRES.kbar_main_grade_lines
    } else {
        mainLayoutCfg.config.lines = KDRES.kbar_main_prcma_lines
    }
    CLAPI.ChartRes.setButtonValue(mainLayoutCfg.config, 'maarea', maarea)

    if (DATAS.isIndex(curKey) == 0) {
        const exright = Init.getUserInfo(chartName, 'exright', 'forword')
        console.log(exright);
        
        if (exright !== 'none') {
            let rights = KDATA.KbarExright(kbars, inData.keyWord, exright)
            mainDataName = 'KBAR.' + exright
            chart.setData(mainDataName, rights)
        }
        CLAPI.ChartRes.setButtonValue(mainLayoutCfg.config, 'exright', Init.getUserInfo(chartName, 'exright'))
    }
    console.log(mainLayoutCfg);
    
    const fchart = curChart.getChart('FWindow')
    // 设置 DAY 为该表的数据源
    // 其他为辅助数据 实际运算时
    const mainchart = chart.createChart('user.kbar', 'system.chart', mainLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        // console.log('KBAR', result)
        if (result.event === 'mousemove') {
            showFkinfo(fchart, result, inData.keyWord)
        }
        if (result.event === 'mouseout') {
            fchart.stopFwindow()
        }
        if (result.event === 'changeAxisY') {
            // console.log('KBAR', result)
            const axisYdata = CLAPI.Utils.copyJsonOfDeep(result.axisYdata)
            const areachart = curChart.getUserChart('Fbar', 'user.area')
            if (areachart) {
                areachart.changeAxisY(axisYdata)
            }
        }
        if (result.event === 'keydown') {
            if (result.code === 'space') {
                inData.showBoard = false
                showFminute(fchart, inData, result)
            }
            if (result.code === 'left' || result.code === 'right') {
                if (fchart.fwindow.winName === 'fline') {
                    showFminute(fchart, inData, result)
                }
                else if (fchart.fwindow.winName === 'finfo') {
                    showFkinfo(fchart, result, inData.keyWord)
                }
            }
        }
        if (result.event === 'btndown') {
            console.log('KBAR', result)
            if (result.name === 'maarea') {
                if (Init.getUserInfo(chartName, result.name) !== result.info) {
                    if (result.info === 'grade') {
                        mainchart.changeCfg({
                            lines: KDRES.kbar_main_grade_lines
                        })
                    } else {
                        mainchart.changeCfg({
                            lines: KDRES.kbar_main_prcma_lines
                        })
                    }
                    // mainchart.onPaint()
                    Init.setUserInfo(chartName, result.name, result.info)
                }
            }
            if (result.name === 'exright') {
                if (Init.getUserInfo(chartName, result.name) !== result.info) {
                    if (result.info === 'none') {
                        mainDataName = 'KBAR'
                    } else {
                        mainDataName = 'KBAR.' + result.info
                        if (!chart.findData(mainDataName)) {
                            let rights = KDATA.KbarExright(kbars, inData.keyWord, result.info)
                            chart.setData(mainDataName, rights)
                        }
                    }
                    // console.log(dataname, rights);
                    chart.bindData(mainchart, mainDataName)
                    chart.bindData(volumechart, mainDataName)
                    chart.onPaint()
                    Init.setUserInfo(chartName, result.name, result.info)
                }
            }
        }
    })
    chart.bindData(mainchart, mainDataName)

    const volumeLoyoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep({
                axisX: {
                    display: 'none',
                },
            },
            CLAPI.ChartRes.CHART_KBAR_SECOND),
        rectMain: CLAPI.getChartRect(region, 1, 3, 0, 1)
    }
    const volumechart = chart.createChart('user.vbar', 'system.chart', volumeLoyoutCfg, function (result) {
        // console.log('VBAR', result)
    })
    chart.bindData(volumechart, mainDataName)

    {
        const curRect = CLAPI.getChartRect(region, 1, 3, 0, 2)
    
        if (region.head > 0) {
            setAnalyHead(curChart, inData, {
                style:  'sidebar',
                top:    curRect.top,
                left:   curRect.left,
                width:  curRect.width,
                height: region.head,
            })
        }
        inData['analyRect'] = {
            top : curRect.top + region.head,
            left : curRect.left,
            width : curRect.width,
            height : curRect.height - region.head,
        }
    }


}

function setHead(curChart, region) {
    const chartName = 'Head'
    const chart = curChart.getChart(chartName)

    const headRect = CLAPI.getChartRect(region)
    const headLayoutCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: KDRES.CHART_KBAR_HEAD,
        rectMain: headRect

    }
    const headchart = chart.createChart('user.kbar', 'system.ctrls', headLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            console.log('KBAR', result)
        }
    })
}
// 画日线
function drawKbar(inData) {

    console.log('Draw ====> Kbar Line')
    // console.log(JSON.stringify(inData));
    console.log(inData);
    
    const curChart = Init.getSysChart()
    // 设置为单一窗口 并返回第一个窗口
    curChart.initChart(['Kbar', 'Head', 'AnalyHead', 'FWindow'])
    const canvas = Init.canvas
    const head = 25 * Init.scale

    // 设置顶部窗口
    setHead(curChart, {
        style:  'sidebar',
        top:    0,
        left:   0,
        width:  canvas.width,
        height: head - Init.scale,
    })

    // 设置第一个窗口
    setKbar(curChart, inData, {
        head: head,
        style:  'splitly',
        top:    head,
        left:   0,
        width:  canvas.width,
        height: canvas.height - head,
    })

    onChangeAnaly(inData, true)

    // curChart.onPaint()
}

async function drawAnaly(analyinfo, inData, isFirst)
{
    const curChart = Init.getSysChart()
    const chartName = 'Kbar'
    const chart = curChart.getChart(chartName)

    analyinfo.lines.title.label = analyinfo.label
    const analyLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 10,
                left: 5,
                right: 10
            }
        },
        config: analyinfo.lines,
        rectMain: inData['analyRect']
    }
    const analychart = chart.createChart('user.line', 'system.chart', analyLayoutCfg, function (result) {
        // console.log('3Bar', result)
    })
    // console.log(analyinfo);
    
    let anaDatas = {}
    switch (analyinfo.analyname) {
        case 'ZLJM':
        case 'SHCC':
        case 'CCYC':
            anaDatas = KDATA.chip3ToSHCC(inData['chip3'], inData['axisXinfo'])
            break;
        case 'CCCB':
        case 'CCSY':
            anaDatas = KDATA.chip3ToCCCB(inData['chip3'], inData['axisXinfo'])
            break;
        case 'DXQL':
            anaDatas = KDATA.signalToDXQL(inData['signal'], inData['axisXinfo'])
            break;
        case 'MMQD':
        case 'APDD':
            anaDatas = KDATA.rpmToMMQD(inData['rpms'], inData['axisXinfo'])
            break;
        case 'DDZB':
        case 'DDHJ':
        default:
            anaDatas = KDATA.IodateToDDTJ(inData['iobar'], inData['axisXinfo'])
            break;
    }
    console.log(isFirst, anaDatas);
    
    chart.setData(analyinfo.analyname, anaDatas)

    chart.bindData(analychart, analyinfo.analyname)

    curChart.onPaint()

}

async function onChangeAnaly(inData, isFirst)
{
    const analyindex = Init.getUserInfo(analyclass, 'analyindex', 0)
    let analyinfo = KDRES.analyinfos[analyindex]
    if (analyinfo === undefined) {
        analyinfo = KDRES.analyinfos[0]
    }
    console.log(analyinfo);
    async function readyrpm() {
        const curKey = Init.getcurKey()
        Init.sendCommand({
                cmds: {
                    "rpms": {
                        "cmd": "get",
                        "subject": curKey + "." + 'rpm_date',
                        "service": "merge/rpm",
                        "info": {
                            "offset": 0,
                        }
                    },
                }
            },
            function reply(datas) {
                if (Init.checkDatas(datas)) {
                    // console.log(datas['rpms']);
                    inData['rpms'] = datas['rpms']
                    drawAnaly(analyinfo, inData, isFirst)
                }
            });
    }
    async function readychip3() {
        const curKey = Init.getcurKey()
        Init.sendCommand({
                cmds: {
                    "chip3": {
                        "cmd": "get",
                        "subject": curKey + "." + 'chip3_date',
                        "service": "merge/chip3",
                        "info": {
                            "offset": 0,
                        }
                    },
                }
            },
            function reply(datas) {
                if (Init.checkDatas(datas)) {
                    // console.log(datas['chip3']);
                    inData['chip3'] = datas['chip3']
                    drawAnaly(analyinfo, inData, isFirst)
                }
            });
    }
    async function readyzeasy0() {
        const curKey = Init.getcurKey()
        Init.sendCommand({
                cmds: {
                    "signal": {
                        "cmd": "get",
                        "subject": curKey + ".db_sminu",
                        "service": "signal/" + 'zeasy0',
                        "info": {
                            "offset": 0,
                        }
                    },
                }
            },
            function reply(datas) {
                if (Init.checkDatas(datas)) {
                    inData['signal'] = datas['signal']
                    drawAnaly(analyinfo, inData, isFirst)
                }
            });
    }   
    switch (analyinfo.analyname) {
        case 'ZLJM':
        case 'SHCC':
        case 'CCCB':
        case 'CCSY':    
        case 'CCYC':
            readychip3()
            break;
        case 'DXQL':
            readyzeasy0()
            break;
        case 'MMQD':
        case 'APDD':
            readyrpm()
            break;
        case 'DDZB':
        case 'DDHJ':
        default:
            drawAnaly(analyinfo, inData, isFirst)
            break;
    }
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulename = argvs.modulename ?? 'kbar'
    if (inData.modulename !== 'kbar') {
        for (let index = 0; index < KDRES.CHART_ANALY_HEAD.ctrls.length; index++) {
            if (inData.modulename === KDRES.CHART_ANALY_HEAD.ctrls[index].clickValue) {
                Init.setUserInfo(analyclass, 'analyindex', index)
                break;
            }
        }
    }
    function onLoadData(curKey, inData) {
        // const curDate = CLAPI.Utils.getMsecDate(inData['info'].datas[0][0]);
        // if (inData['newbar'] && CLAPI.getData(inData['newbar'], 'msecstamp', -1) !== 0) {
        //     inData.lastMsec = CLAPI.Utils.strMsecToMTime(CLAPI.getData(inData['newbar'], 'msecstamp', -1));
        // }
        // inData.lastDate = CLAPI.Utils.getMsecDate(inData.lastMsec);
        
        let ioname = "inout_date"
        if (DATAS.isIndex(curKey)) {
            ioname = "inout_idx_date"
        }
        const cmds = {
            "iobar": {
                "cmd": "get",
                "subject": curKey + "." + ioname,
                "service": "merge/aiodb",
                "info": {
                    "offset": 0,
                    "fields": KDATA.iodate_fields
                }
            },
            "minfo": {
                "cmd": "get",
                "subject": curKey + ".alpha_info",
                "service": "merge/ainfo",
                "info": {
                    "offset": 0
                }
            },     
        }
        if (inData.lastDate > inData.diskDate) {
            cmds['newbar'] = {
                    "cmd" : "redis", 
                    "subject" : "market", 
                    "service": '47.242.109.110:17329', 
                    "info" : {
                        "command" : "hget " + "market:kbar:" + inData.lastDate + " " + curKey
                    }
                }
        }
        Init.sendCommand({ cmds },
            function reply(datas) {
                if (Init.checkDatas(datas, ['newbar'])) {
                    inData['iobar'] = datas['iobar']
                    inData['minfo'] = datas['minfo']
                    if (datas['newbar'] && datas['newbar'].infos) {
                        KDATA.concatKbar(inData['iobar'], datas['newbar'])
                    }
                    drawKbar(inData)
                }
            });
    }
    let curKey = Init.getcurKey()
    Init.sendCommand({
            cmds: {
                "info": {
                    "cmd": "get",
                    "subject": curKey + ".alpha_info",
                    "service": "merge/ainfo",
                    "info": {
                        "offset": -1
                    }
                },
                "tradedate" : { 
                    "cmd" : "redis", 
                    "subject" : "tradedate", 
                    "service": '47.242.109.110:17329', 
                    "info" : {
                        "command" : "get " + "monitor:tradedate"
                    }
                },
                // "newps": {
                //     "cmd": "mc2p",
                //     "subject": "getminute",
                //     "service": "realtdx.py",
                //     "info": "SH600600"
                // }
            }
        },
        function reply(datas) {
            console.log(datas)
            if (Init.checkDatas(datas)) {
                Init.setcurKey(curKey);
                inData['info'] = datas['info']
                inData.diskDate = CLAPI.Utils.getMsecDate(CLAPI.getData(inData['info'], 'msec', -1));
                inData.lastDate = inData.diskDate
                if (datas['tradedate'].tag === 0) {
                    inData.lastDate = datas['tradedate'].infos.currdate
                }
                onLoadData(curKey, inData)
            }
        });
}

// 注册方法到参数表